import gql from 'graphql-tag';

export const createTabletUrlForStartingASession = gql`
    query createTabletUrlForStartingASession(
        $subjectId: String!
        $version: Int!
        $locale: String
        $userName: String!
        $afterMeeting: Boolean!
        $initializer: String!
    ) {
        createTabletUrlForStartingASession(
            subjectId : $subjectId
            version : $version
            locale : $locale
            userName: $userName
            afterMeeting: $afterMeeting
            initializer: $initializer
        )
    }
`;